/**
 * WebSocket base URL.
 * Dev / localhost: тот же origin (прокси Vite).
 * Иначе: VITE_WS_URL → VITE_PUBLIC_API_URL → тот же origin.
 *
 * Build-time values come from Jenkins build args and Helm `values.*.VITE_*`.
 */
export function getWebSocketBaseUrl(): string {
  const env = import.meta.env
  const isDev = env.DEV === true
  const isLocalhost =
    typeof location !== 'undefined' &&
    (location.hostname === 'localhost' || location.hostname === '127.0.0.1') &&
    !!location.host

  if ((isDev || isLocalhost) && typeof location !== 'undefined' && location.host) {
    const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${location.host}`
  }

  const wsu = env.VITE_WS_URL
  const apiu = env.VITE_PUBLIC_API_URL

  const currentWsOrigin = (): string | null => {
    if (typeof location === 'undefined' || !location.host) return null
    const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${location.host}`
  }

  const shouldUseCurrentOrigin = (host: string): boolean => {
    if (typeof location === 'undefined') return false
    const configuredHost = host.split(':')[0]
    const currentHost = location.hostname
    const configuredIsLocal =
      configuredHost === 'localhost' || configuredHost === '127.0.0.1' || configuredHost === '[::1]' || configuredHost === '::1'
    const currentIsLocal = currentHost === 'localhost' || currentHost === '127.0.0.1' || currentHost === '::1'
    return configuredIsLocal && !!currentHost && !currentIsLocal
  }

  if (wsu && typeof wsu === 'string' && wsu.trim()) {
    let u = wsu.trim()
    if (u.startsWith('http://')) u = `ws://${u.slice(7)}`
    else if (u.startsWith('https://')) u = `wss://${u.slice(8)}`
    try {
      const a = new URL(u)
      if (shouldUseCurrentOrigin(a.host)) return currentWsOrigin() ?? u.replace(/\/+$/, '')
    } catch {
      /* ignore */
    }
    return u.replace(/\/+$/, '')
  }

  if (apiu && typeof apiu === 'string' && apiu.trim()) {
    let u = apiu.trim()
    if (u.startsWith('http://')) u = `ws://${u.slice(7)}`
    else if (u.startsWith('https://')) u = `wss://${u.slice(8)}`
    else u = u.startsWith('ws') ? u : `wss://${u}`
    try {
      const a = new URL(u)
      if (shouldUseCurrentOrigin(a.host)) return currentWsOrigin() ?? `${a.protocol}//${a.host}`
      const secure = a.protocol === 'wss:' || a.protocol === 'https:'
      return `${secure ? 'wss:' : 'ws:'}//${a.host}`
    } catch {
      /* ignore */
    }
  }

  const protocol = typeof location !== 'undefined' && location.protocol === 'https:' ? 'wss:' : 'ws:'
  const host = typeof location !== 'undefined' ? location.host : ''
  if (host) return `${protocol}//${host}`
  return 'ws://localhost'
}

/** Полный WS URL, path с ведущим слэшем, напр. `/api/v1/ws/tickets`. */
export function getWebSocketUrl(path: string): string {
  const base = getWebSocketBaseUrl()
  const p = path.startsWith('/') ? path : `/${path}`
  return `${base.replace(/\/+$/, '')}${p}`
}
